/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyFamilyPharmacistLicense,
  PharmacyFamilyPharmacistLicenseFromJSON,
  PharmacyFamilyPharmacistLicenseFromJSONTyped,
  PharmacyFamilyPharmacistLicenseToJSON,
  PharmacyFamilyPharmacistLink,
  PharmacyFamilyPharmacistLinkFromJSON,
  PharmacyFamilyPharmacistLinkFromJSONTyped,
  PharmacyFamilyPharmacistLinkToJSON,
  PharmacyRequestFamilyPharmacistImage,
  PharmacyRequestFamilyPharmacistImageFromJSON,
  PharmacyRequestFamilyPharmacistImageFromJSONTyped,
  PharmacyRequestFamilyPharmacistImageToJSON,
} from "./";

export const PostFamilyPharmacistsRequestBodyTypename = "PostFamilyPharmacistsRequestBody" as const;

/**
 *
 * @export
 * @interface PostFamilyPharmacistsRequestBody
 */
export interface PostFamilyPharmacistsRequestBody {
  /**
   *
   * @type {string}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  aboutMyself?: string;
  /**
   *
   * @type {string}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  firstName: string;
  /**
   *
   * @type {PharmacyRequestFamilyPharmacistImage}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  image: PharmacyRequestFamilyPharmacistImage;
  /**
   *
   * @type {boolean}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  isPublic?: boolean;
  /**
   *
   * @type {string}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  kanaFirstName: string;
  /**
   *
   * @type {string}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  kanaLastName: string;
  /**
   *
   * @type {string}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  lastName: string;
  /**
   *
   * @type {PharmacyFamilyPharmacistLicense}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  license: PharmacyFamilyPharmacistLicense;
  /**
   *
   * @type {Array<PharmacyFamilyPharmacistLink>}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  links?: Array<PharmacyFamilyPharmacistLink>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostFamilyPharmacistsRequestBody
   */
  readonly __typename?: string;
}

export function PostFamilyPharmacistsRequestBodyFromJSON(json: any): PostFamilyPharmacistsRequestBody {
  return PostFamilyPharmacistsRequestBodyFromJSONTyped(json, false);
}

export function PostFamilyPharmacistsRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostFamilyPharmacistsRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostFamilyPharmacistsRequestBodyTypename,

    aboutMyself: !exists(json, "about_myself") ? undefined : json["about_myself"],
    firstName: json["first_name"],
    image: PharmacyRequestFamilyPharmacistImageFromJSON(json["image"]),
    isPublic: !exists(json, "is_public") ? undefined : json["is_public"],
    kanaFirstName: json["kana_first_name"],
    kanaLastName: json["kana_last_name"],
    lastName: json["last_name"],
    license: PharmacyFamilyPharmacistLicenseFromJSON(json["license"]),
    links: !exists(json, "links") ? undefined : (json["links"] as Array<any>).map(PharmacyFamilyPharmacistLinkFromJSON),
  };
}

export function PostFamilyPharmacistsRequestBodyToJSON(object?: PostFamilyPharmacistsRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    about_myself: value.aboutMyself,
    first_name: value.firstName,
    image: PharmacyRequestFamilyPharmacistImageToJSON(value.image),
    is_public: value.isPublic,
    kana_first_name: value.kanaFirstName,
    kana_last_name: value.kanaLastName,
    last_name: value.lastName,
    license: PharmacyFamilyPharmacistLicenseToJSON(value.license),
    links: value.links === undefined ? undefined : (value.links as Array<any>).map(PharmacyFamilyPharmacistLinkToJSON),
  };
}
